exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n    background-color: #fafafa;\n    font-family: roboto;\n}\n\nmain {\n    padding-top: 64px;\n    max-width: 800px;\n    margin: 50px auto;\n}\n\nmain>h1 {\n    font-size: 38px;\n    font-weight: 400;\n}\n\n#boxes {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr 1fr;\n        grid-template-columns: 1fr 1fr 1fr;\n    grid-gap: 10px;\n}\n\nh2 {\n    font-weight: 300;\n}\n\n.amount, .user {\n    font-weight: 400;\n}\n\n.containers {\n    background-color: white;\n    -webkit-box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n            box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    border-radius: 2px;\n    cursor: pointer;\n    padding: 5px 15px;\n}\n\n#spinner {\n    margin: 0 auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/browse/browse.component.css
// module id = ../../../../../src/app/ui/browse/browse.component.css
// module chunks = main